<ion-content class="">
  <div class="scroll-content-modal">
    <app-header-modal [title]="point?.name || ''" [showToggle]="true" [showClose]="true" [maxHeight]="38"
      [bgColor]="'var(--color-gray-100)'" (toggleHeight)="toggleModalHeight()" (close)="closeModal()">
    </app-header-modal>

    @if (point) {
    <div class="modal-content recycling-point-modal">
      <h3 class="point-name h3-bold scrollable-title notranslate" translate="no">
        {{ point.name }}
      </h3>
      <div class="card-content">
        <!-- Header section with name and entity type -->
        <!-- Entity Type Badge -->

        <!-- Address Section + Trust/Source icons -->
        @if (addressString()) {
        <div class="info-row section-margin-2xs clickable" (click)="repointMapOnPoint($event)">
          <div class="row-content address-field">
            <img class='icon icon-primary margin-r-xs icon-20' src="assets/icons/location.svg" alt="Location">
            <p class="row-text p notranslate" translate="no">{{ addressString() }}</p>
            <app-trust-source-badge
              [validation]="point.validation"
              [dataSource]="point.dataSource">
            </app-trust-source-badge>
          </div>
        </div>
        }
        <!-- Description Section -->
        @if (point.description) {
        <div class="description-section section-margin-2xs">
          <app-leer-mas [text]="point.description" [lineClamp]="3" [threshold]="150">
          </app-leer-mas>
        </div>
        }

        <!-- Materials Section -->
        <app-modal-materials-section
          [materialInput]="inputMaterials()"
          [materialOutput]="outputMaterials()">
        </app-modal-materials-section>

        <!-- Reference Links + Website -->
        <div class="section-margin-xs">
          <app-links-chips [links]="point.referenceLinks || []" [website]="point.sitio_web" [maxVisible]="4">
          </app-links-chips>
        </div>

        <!-- Contact Information -->
        <app-contact-info [phone]="point.telefono" [showWhatsApp]="true"
          [showSocialMedia]="true" [socialMedia]="point.socialMedia" (contactAction)="onContactAction($event)">
        </app-contact-info>

        <!-- Action Buttons Slider -->
        <div class="action-slider-section">
          <app-action-buttons-slider [actions]="actionButtons" (actionClick)="onActionButtonClick($event)">
          </app-action-buttons-slider>
        </div>

        <!-- Schedule Section -->
        @if (point.schedules && point.schedules.length > 0) {
        <div class="schedule-section section-margin-s">
          <app-schedule [scheduleData]="point.schedules" variant="modal" [showStatus]="true" [showHours]="true"
            [showDayPills]="true" customClasses="sub margin-t-s">
          </app-schedule>
        </div>
        }

        <!-- Suggest Edit Button (only when lacking materials, address, or schedule) -->
        @if (showEditButton()) {
        <div class="button-section section-margin-sm">
          <div class="btn-edit push-btn primary-invert-color-button full-width-button btn-sm" (click)="suggestEdit()">
            <button class="inner-button edit p" [title]="'placeModal.suggestEditTitle' | t">
              <img src="assets/icons/edit.svg" class="icon-primary icon-20" alt="">
              <span class='btn-text p-semibold line-clamp-1'>{{ 'placeModal.editAddInfo' | t }}</span>
            </button>
          </div>
        </div>
        }

        <!-- Social Section (reports + status + comments) -->
        <div class="">
          <app-social-section [entityId]="point.id" entityType="place">
          </app-social-section>
        </div>

      </div>
    </div>
    }
    <div class="spacing-100"></div>
  </div>
</ion-content>

<!-- Action Sheet for Share Options -->
<ion-action-sheet [isOpen]="isActionSheetOpen" [buttons]="actionSheetButtons" (didDismiss)="isActionSheetOpen = false">
</ion-action-sheet>